<template>
	<div>
		<div class="xfck">
			<div class="cfck-content">
				<a
					href="tencent://message/?Menu=yes&uin=1098991971&Site=80fans&Service=300&sigT=45a1e5847943b64c6ff3990f8a9e644d2b31356cb0b4ac6b24663a3c8dd0f8aa12a545b1714f9d45">
					<img src="../../static/image/qq_xfck.png" class="qq-img" />
					<p class="qq_xfck">QQ</p>
				</a>
			</div>
			<div class="cfck-content bj" @click="tiaozhuan">
				<img src="../../static/image/dh_xfck.png" class="dh-img" />
				<p class="dh_xfck">电话</p>
			</div>
			<div class="cfck-content wx">
				<img src="../../static/image/gzwm.png" class="wx-img" />
				<p class="wx_xfck">关注我们</p>
				<ul class="child_menu" v-for="(item,i) in menu_list" :key="item.i" :style='{"left":-(i+1)*73+"px"}'>
					<li>
						<div class="menu_item">
							<img :src="item.pic_logo" alt="" style='width:36px;height:36px'>
							<span style='color:#fff'>{{item.pic_name}}</span>
						</div>
						<div class="item_code">
							<img :src="item.pic_url" alt="" style="width:100%;height:100%;">
						</div>
					</li>
				</ul>
			</div>
			<div class="cfck-content" @click="showed">
				<img src="../../static/image/kf_xfck.png" class="kf-img" />
				<p class="kf_xfck">在线咨询</p>
			</div>
			<div class="cfck-content" @click="backTop">
				<img src="../../static/image/top.png" class="kftop-img" />
				<!-- <p class="kf_xfck">TOP</p> -->
			</div>
		</div>

		<div class="content_left">
			<div class="content_left_top">
				<img src="../../static/image/call_me.png" alt="" style="width:150px;height: 150px;">
				
				<div class="content_left_bottom">
					<img src="../../static/image/content_left_bottom_qrcode.png" alt="" style="width: 150px;height: 180px;padding-top: 20px;">
					<p style="width: 180px;color: #FFFFFF;text-align: center;padding-bottom: 10px;">请用微信扫码联系客服</p>
				</div>


			</div>



		</div>

		<!-- <transition name="bounce" enter-active-class="bounceInLeft" leave-active-    
   class="none">
	<div class="djzx" ref="djzk" v-show="show">
		<div class="title-bj">
			<div class="liuyan">请您留言</div>
			<div class="xiaochuang" @click="hide"></div>
		</div>
		<div class="title">
			<p class="title-jy">河南简云网络科技有限公司</p>
			<p class="title-dh">400-8086-828</p>
		</div>
		<Form ref="formInline" :model="formInline" :rules="ruleInline" inline>
		<FormItem prop="liuyantext" class="form-wbk">
            <textarea class="wbk" type="text" v-model="formInline.liuyantext" placeholder="请在此输入留言内容,我们会尽快与您联系(必填)">
            </textarea>
        </FormItem>
        <FormItem prop="name" class="form-width">
            <Input type="text" v-model="formInline.name" placeholder="姓名(必填)">
                <Icon class="iconfont icon-ren bjtb" slot="prepend" ></Icon>
            </Input>
        </FormItem>
        <FormItem prop="phone" class="form-width">
            <Input type="text" v-model="formInline.phone" placeholder="电话(必填)">
                <Icon class="iconfont icon-dianhua bjtb" slot="prepend"></Icon>
            </Input>
        </FormItem>
         <FormItem prop="mail" class="form-width">
            <Input type="text" v-model="formInline.mail" placeholder="邮箱">
                <Icon class="iconfont icon-youxiang bjtb" slot="prepend"></Icon>
            </Input>
        </FormItem>
        <FormItem prop="adress" class="form-width">
            <Input type="text" v-model="formInline.adress" placeholder="地址">
                <Icon class="iconfont icon-dizhi bjtb" slot="prepend"></Icon>
            </Input>
        </FormItem>
        <FormItem >
            <Button class="button" type="primary" @click="handleSubmit('formInline')">发送</Button>
        </FormItem>
    </Form>
	</div>
	</transition>

	<div class="xck-title">
			<div class="liuyan">请您留言</div>
			<div class="xiaochuang zhankai"></div>
    </div>-->
		<tankuang ref="tankuang"></tankuang>
	</div>
</template>
<script>
	import tankuang from "./tankuang.vue";
	export default {
		name: "xfck",
		data() {
			return {
				menu_list: []
			};
		},
		created() {
			this.pic_code()
		},
		methods: {
			backTop() {
				document.body.scrollTop = 0;
				document.documentElement.scrollTop = 0;
			},
			tiaozhuan() {
				this.$router.push({
					path: "/lianxi"
				});
			},
			showed() {
				this.$refs.tankuang.show = true;
			},
			pic_code() {
				var that = this;
				// console.log(that.CDN_IMG)
				var url = that.baseUrl + "/jianyun/api/mall.php?c=about_us/getPic";
				that.axios
					.get(url, {
						params: {
							pic_type: 1
						}
					})
					.then(res => {
						if (res.data.success) {
							that.$emit('func', res.data.data.list)
							that.menu_list = res.data.data.list
						} else {
							this.$Message.warning(res.data.msg);
						}
					})
					.catch(error => {
						// console.log(error);
					});
			}
		},
		components: {
			tankuang
		}
	};
</script>
<style scoped>
	.xfck {
		position: fixed;
		bottom: 170px;
		right: 11px;
		z-index: 10000;
	}

	.content_left {
		position: fixed;
		top: 365px;
		left: 11px;
		display: grid;
		z-index: 10000;
	}

	.content_left_top {
		width: 180px;
		height: 100px;
		/* background: rgba(0, 0, 0, .3);
		border: 1px solid rgba(255, 137, 34, .5); 
		margin-bottom: 10px;*/
		cursor: pointer;
		text-align: center;
		position: relative;
	}

	/* .content_left_top:hover {
		background: rgba(255, 137, 34, 1);
	} */

	.content_left_bottom {
		/* margin-top: 30px; */
		display: none;
		background: rgba(0,0,0,.3);
	}

	.content_left_top:hover .content_left_bottom {
		display: block;
	}

	.cfck-content {
		width: 72px;
		height: 72px;
		background: rgba(0, 0, 0, 0.3);
		border: 1px solid rgba(255, 137, 34, 0.5);
		margin-bottom: 10px;
		cursor: pointer;
		text-align: center;
	}

	.cfck-content:hover {
		background: rgba(255, 137, 34, 1);
	}

	.qq-img,
	.dh-img,
	.wx-img,
	.kf-img {
		display: inline-block;
		margin-top: 10px;
	}

	.qq-img {
		width: 30px;
		height: 34px;
	}

	.dh-img {
		width: 36px;
		height: 36px;
	}

	.wx-img {
		width: 36px;
		height: 29px;
	}

	.kf-img {
		width: 36px;
		height: 26px;
	}

	.kftop-img {
		margin-top: 20px;
		width: 36px;
		height: 29px;
	}

	.qq_xfck,
	.dh_xfck,
	.wx_xfck,
	.kf_xfck {
		color: rgba(255, 255, 255, 1);
		font-family: PingFang-SC-Regular;
		font-weight: 400;
		font-size: 14px;
	}

	.kf_xfck {
		font-size: 12px;
	}

	.wx {
		position: relative;
	}

	.child_menu {
		min-width: 72px;
		height: 72px;
		position: absolute;
		top: -1px;
		background: rgba(0, 0, 0, 0.3);
		list-style: none;
		display: none;
	}

	.child_menu:hover {
		background: rgba(255, 137, 34, 1);
	}

	.child_menu li {
		height: 100%;
		position: relative;
	}

	.menu_item {
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.item_code {
		width: 120px;
		height: 120px;
		position: absolute;
		left: -50px;
		display: none;
	}

	.child_menu:hover .item_code {
		display: block;
	}

	.wx:hover .child_menu {
		display: block;
	}
</style>



// WEBPACK FOOTER //
// src/components/xfck.vue